export const supportConstants = {
  SUPPORT_CREATION_REQUEST: 'SUPPORT_CREATION__REQUEST',
  SUPPORT_CREATION_SUCCESS: 'SUPPORT_CREATION_SUCCESS',
  SUPPORT_CREATION_FAILURE: 'SUPPORT_CREATION_FAILURE',
};



// WEBPACK FOOTER //
// ./src/constants/support.constants.js